import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { isSkipCaptchaEnabled } from "./skip_captcha";
export function loadTencentCaptcha(_x) { return _loadTencentCaptcha.apply(this, arguments); }
function _loadTencentCaptcha() { _loadTencentCaptcha = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee(language) { var _process$env$GATSBY_T; var skipCaptcha, tencentCaptchaAppId, lang, isSuccess; return _regeneratorRuntime.wrap(function _callee$(_context) { while (1) {
    switch (_context.prev = _context.next) {
        case 0:
            skipCaptcha = isSkipCaptchaEnabled();
            if (!skipCaptcha) {
                _context.next = 3;
                break;
            }
            return _context.abrupt("return", { ticket: "test-ticket", randstr: "test-randstr" });
        case 3:
            tencentCaptchaAppId = (_process$env$GATSBY_T = process.env.GATSBY_TENCENT_CAPTCHA_APP_ID) !== null && _process$env$GATSBY_T !== void 0 ? _process$env$GATSBY_T : "";
            lang = language == 'cn' ? 'zh-cn' : language == 'hk' ? 'zh-hk' : 'en';
            isSuccess = new Promise(function (resolve) { try {
                var captcha = new TencentCaptcha(tencentCaptchaAppId, function (res) { if (res.ret === 0) {
                    resolve({ ticket: res.ticket, randstr: res.randstr });
                }
                else {
                    resolve({});
                } }, { loading: false, userLanguage: lang });
                captcha.show();
            }
            catch (e) {
                console.error(e);
                resolve({});
            } });
            _context.next = 8;
            return isSuccess;
        case 8: return _context.abrupt("return", _context.sent);
        case 9:
        case "end": return _context.stop();
    }
} }, _callee); })); return _loadTencentCaptcha.apply(this, arguments); }
